import script from "./messageContentView.vue?vue&type=script&setup=true&lang=ts"
export * from "./messageContentView.vue?vue&type=script&setup=true&lang=ts"

import "./messageContentView.vue?vue&type=style&index=0&id=9b98f9d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b98f9d2"]])

export default __exports__